import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { CreditLimitPreferenceTypes } from 'constants/enums/creditLimitPreferenceTypes'

export const CreditLimitPreferenceFormUK = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'CreditLimitPreferenceForm',
		collapsable: false,
		description: t('Credit limit preferences'),
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'creditLimitPreference',
				type: 'radio',
				description: t('forms:CreditLimitPreferenceDescription'),
				options: [
					{
						value: CreditLimitPreferenceTypes.Automatically,
						label: t('forms:AutoIncrease'),
					},
					{
						value: CreditLimitPreferenceTypes.CustomerApproved,
						label: t('forms:CheckWithMe'),
					},
				],
				visible: true,
				col: 12,
			},
		],
	}
}
